import { on, off, popup } from '@telegram-apps/sdk-react';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';

import { ReportReason } from '@/enums/apiEnums.ts';
import { reasonToTranslationMap } from '@/components/Messanger/ReportModal.tsx';

export const useReportUnmatchAction = (
  id: string,
  name: string,
  reason: ReportReason,
  onUnmatchConfirmed: (id: string, reason: ReportReason) => void
) => {
  const { t } = useTranslation();
  const lastIdRef = useRef<string | null>(null);
  const lastNameRef = useRef<string | null>(null);
  const lastReasonRef = useRef<ReportReason | null>(null);

  useEffect(() => {
    const handlePopupClosed = (payload: { button_id: string }) => {
      if (
        payload.button_id === 'report_block' &&
        lastIdRef.current !== null &&
        lastReasonRef.current !== null
      ) {
        onUnmatchConfirmed(lastIdRef.current, lastReasonRef.current);
        lastIdRef.current = null;
        lastNameRef.current = null;
        lastReasonRef.current = null;
      }

      if (payload.button_id === 'cancel') {
        lastIdRef.current = null;
        lastNameRef.current = null;
        lastReasonRef.current = null;
      }
    };

    // eslint-disable-next-line
    // @ts-ignore
    on('popup_closed', handlePopupClosed);

    return () => {
      // eslint-disable-next-line
      // @ts-ignore
      off('popup_closed', handlePopupClosed);
    };
  }, []);

  return async () => {
    lastIdRef.current = id;
    lastNameRef.current = name;
    lastReasonRef.current = reason;
    await popup.show({
      title: t('report_and_unmatch_user_popup_title', { name }),
      message: t('report_and_unmatch_user_popup_subtitle', {
        reason: t(reasonToTranslationMap[reason])
      }),
      buttons: [
        {
          id: 'report_block',
          type: 'destructive',
          text: t('confirm_report_unmatch_user_title')
        },
        {
          id: 'cancel',
          type: 'default',
          text: t('cancel_title')
        }
      ]
    });
  };
};
